import cn from 'classnames'
import * as React from 'react'

import { FormattedMessage } from 'react-intl'

import styles from './price.module.scss'

interface IPriceProps {
  amount: number
  className?: string
  prefix?: 'none' | 'currency' | 'starting-at'
  variant?: 'normal' | 'large'
  theme?: 'standard' | 'light'
}

export default function Price(props: IPriceProps) {
  const { amount, className, prefix = 'none', variant = 'standard', theme = 'standard' } = props

  return (
    <div
      className={cn([styles.root, className, variant === 'large' && styles.large, theme === 'light' && styles.light])}
    >
      {prefix === 'starting-at' && (
        <span className={styles.prefix}>
          <FormattedMessage defaultMessage="Från" id="start.compare-free.price-from" />
        </span>
      )}
      {prefix === 'currency' && <span className={styles.prefix}>{'SEK'}</span>}
      {/* SMELL: Should use FormattedCurrency from @dooer/js-react-intl  */}
      <span className={styles.amount}>{amount}</span>
      <span className={styles.period}>
        {'/'}
        <FormattedMessage defaultMessage="mån" id="start.compare-free.price-month" />
      </span>
    </div>
  )
}
